var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circuit-container"},[_c('circuit-table',{attrs:{"tableData":_vm.tableData,"totalCount":_vm.totalCount,"downloadUrl":"/dataModule/routeInfoDownload"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }